const windowObj = typeof window !== 'undefined' ? (window as any) : null;

export interface AmplitudeIdentify {
  /** increment a user property by a given value (can also be negative to decrement). */
  add(key: string, value: number | string): AmplitudeIdentify;
  /** Append a value or values to a user property */
  append(key: string, value: unknown): AmplitudeIdentify;
  /** Prepend a value or values to a user property */
  prepend(key: string, value: unknown): AmplitudeIdentify;
  /** Sets the value of a given user property */
  set(key: string, value: unknown): AmplitudeIdentify;
  /** Sets the value of a given user property only once */
  setOnce(key: string, value: unknown): AmplitudeIdentify;
  /** Unset and remove a user property */
  unset(key: string): AmplitudeIdentify;
}

export interface AmplitudeRevenue {
  setProductId(productId: string): AmplitudeRevenue;
  setQuantity(quantity: number): AmplitudeRevenue;
  setPrice(price: number): AmplitudeRevenue;
  setRevenueType(revenueType: string): AmplitudeRevenue;
  setEventProperties(eventProperties: any): AmplitudeRevenue;
}

export interface AmplitudeClient {
  init(
    apiKey: string,
    userId?: string,
    config?: unknown,
    callback?: (client: AmplitudeClient) => void,
  ): void;

  setVersionName(versionName: string): void;

  isNewSession(): boolean;
  setSessionId(sessionId: number): void;
  getSessionId(): number;

  setDomain(domain: string): void;
  setUserId(userId: string | null): void;

  setDeviceId(id: string): void;
  regenerateDeviceId(): void;

  identify(identifyObj: AmplitudeIdentify, optCallback?: () => void): void;

  setUserProperties(properties: any): void;
  setGlobalUserProperties(properties: any): void;
  clearUserProperties(): void;

  setOptOut(enable: boolean): void;

  setGroup(groupType: string, groupName: string | string[]): void;

  logEvent(event: string, data?: unknown, callback?: () => void): void;
  logEventWithGroups(
    event: string,
    data?: unknown,
    groups?: unknown,
    callback?: () => void,
  ): void;
  logRevenueV2(revenueObj: AmplitudeRevenue): void;
  logRevenue(pric: number, quantity: number, product: string): void;
  logEventWithTimestamp(
    event: string,
    data?: unknown,
    timestamp?: number,
    callback?: () => void,
  ): void;

  Identify: new () => AmplitudeIdentify;
  Revenue: new () => AmplitudeRevenue;
}

export function getAmplitude (): AmplitudeClient | null {
  if (windowObj.amplitude == null) return null;

  return windowObj.amplitude.getInstance?.() as AmplitudeClient | null;
}

export function logAmplitude (type: string, data?: unknown): void {
  const amplitude = getAmplitude();

  if (amplitude == null) return;

  amplitude.logEvent(type, data);
}
